import _ from 'lodash'

import { sortOrderKeys } from '../../configuration/sorting'

export const CONFIGURE_SORT_ORDER = 'CONFIGURE_SORT_ORDER'
export const SET_SORT_ORDER = 'SET_SORT_ORDER'

export const configureSortOrder = (queryParams, defaultSortOrder) => (dispatch) => {
  const sortOrderParam = _.find(queryParams, (params, paramKey) => _.toLower(paramKey) === 'sortby')
  const isValid = sortOrderParam && Boolean(_.find(sortOrderKeys, sortKey => _.toLower(sortKey) === _.toLower(sortOrderParam)))
  const sortOrder = sortOrderParam && isValid
    ? sortOrderParam
    : defaultSortOrder
  dispatch({ type: CONFIGURE_SORT_ORDER, payload: sortOrder })
}

export const setSortOrder = sortOrder => {
  return dispatch => {
    dispatch({ type: SET_SORT_ORDER, payload: sortOrder })
  }
}
